/**
 * Where to send somebody after they sign in or sign up, from `?next=`.
 *
 * Only a path of our own, or null. Checking the first two characters is not
 * enough: browsers read `\` as `/`, so `/\evil.com` is `//evil.com` — another
 * site — by the time it reaches the address bar, and a tab or a newline in the
 * middle is dropped just as quietly. So the rule is what the browser would
 * actually do with it: resolve it against this origin and keep it only if it
 * is still here.
 */
export function safeNext(next) {
  if (typeof next !== 'string' || !next.startsWith('/')) {
    return null;
  }
  // eslint-disable-next-line no-control-regex
  if (next.includes('\\') || /[\u0000-\u001f\u007f]/.test(next)) {
    return null;
  }

  let url;
  try {
    url = new URL(next, window.location.origin);
  } catch {
    return null;
  }
  if (url.origin !== window.location.origin) {
    return null;
  }

  return `${url.pathname}${url.search}${url.hash}`;
}
